// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'


function calculateForm5(){
  var stuwdruk = $('.acf-field').find("[data-name='form5_stuwdruk']").find(':input').val();
  var zone = $('.acf-field').find("[data-name='form5_zone']").find('label.selected > input[type="radio"]').val();
  var ankers_hoh = $('.acf-field').find("[data-name='form5_anker_hoh']").find(':input').val();
  var hoogte_element = $('.acf-field').find("[data-name='form5_hoogte']").find(':input').val();
  var houtkwaliteit = $('.acf-field').find("[data-name='form5_kwaliteit']").find('label.selected > input[type="radio"]').val();

  var afmeting_arm = $('.acf-field').find("[data-name='form5_afmeting_arm']").find(':input').val();
  var diameter = $('.acf-field').find("[data-name='form5_diameter']").find(':input').val();
  var staal_kwaliteit = $('.acf-field').find("[data-name='form5_staalkwaliteit']").find('label.selected > input[type="radio"]').val();

  $.ajax({
    url: '/wp-admin/admin-ajax.php',
    data: {
      action: 'form5Calculate',
      stuwdruk: stuwdruk,
      zone: zone,
      ankers_hoh: ankers_hoh,
      hoogte_element: hoogte_element,
      houtkwaliteit: houtkwaliteit,
      afmeting_arm: afmeting_arm,
      diameter: diameter,
      staal_kwaliteit: staal_kwaliteit
    },
    method: 'POST',
    success: function (html) {
      $('.calculation-result').html(html);
      $('#form5Calc .acf-form-submit input[type="submit"]').prop("disabled", false).addClass('active');
    }
  });
}

$(document).ready(function(){

  $('#form5Calc .acf-form-submit input[type="submit"]').prop("disabled", true);
  $('#form5Calc .acf-form-submit').append('<input type="submit" id="calculate_form5" value="Berekenen" class="calculate-btn btn btn--primary"/>');

  $('#calculate_form5').click(function(e){
    e.preventDefault();
    calculateForm5();
  });

});



// WEBPACK FOOTER //
// ./resources/assets/js/form5.js